import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import W8PdfInterface from './interfaces/W8PdfInterface.interface';

export interface GenerateSignLinkData {
	custodian_request_id: number;
}

export interface GenerateSignLinkResponse {
	status: boolean;
	w8_pdf: W8PdfInterface;
}

const generateSignLink = configRequest<GenerateSignLinkResponse, GenerateSignLinkData>({
	requestPrefix: 'applications/generateSignLink',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.GENERATE_SIGN_LINK(),
		method: HTTP_METHODS_ENUM.POST,
		data,
	}),
});

export const generateSignLinkValidation = configRequest<GenerateSignLinkResponse, GenerateSignLinkData>({
	requestPrefix: 'applications/generateSignLinkValidation',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.GENERATE_SIGN_LINK(),
		method: HTTP_METHODS_ENUM.POST,
		data: {
			...data,
			only_validate: true,
		},
	}),
});

export default generateSignLink;
